import { api_login_url } from "./authApi";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { parser_login } from "./authParser";
import { authenticate } from "../../helpers/cookies";

export const login = createAsyncThunk(
    "login",
    async (payload) => {
      try {
        const {username,password,company_domain} = payload;
        let formData = new FormData();
        formData.append('username', username);
        formData.append('password', password);
        formData.append('company_domain', company_domain);
        const response = await api_login_url(formData);
        const data = parser_login(response);
        return {data};
      } catch (error) {
        throw new Error(error);
      }
    }
  );

const initialState = {
    login_is_loading: false,
    show_password : false,
};

export const loginSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
      setShowPassword: (state, action) => {
        state.show_password = action.payload;
      },
      setResetState:(state,action) => {
        state.show_password = false;
        state.login_is_loading = false;
      }
    },
    extraReducers: (builder) => {
        builder.addCase(login.pending, (state) => {
          state.login_is_loading = true;
        })
        builder.addCase(login.fulfilled, (state,action) => {
          authenticate(action.payload.data, () => window.location.replace('/'));
          state.login_is_loading = false;
        })
        builder.addCase(login.rejected, (state) => {
          state.login_is_loading = false;
        })
    },
});

// Action creators are generated for each case reducer function
export const {
  setShowPassword,
  setResetState
} = loginSlice.actions;
export default loginSlice.reducer;